export const crmConfigTypes = {
    entrata: 'entrata',
    eldermark_v2: 'eldermark_v2',
    anyone_home: 'anyone_home',
    eldermark: 'eldermark',
    yardi: 'yardi',
    yardi_soap: 'yardi_soap',
    yardi_sipp: 'yardi_sipp',
    realpage: 'realpage',
    rent_manager: 'rent_manager',
    hospice_md: 'hospice_md',
    rentcafe: 'rentcafe',
    rentcafe_v2: 'rentcafe_v2',
    meet_elise: 'meet_elise',
    adf: 'adf',
    enquire: 'enquire',
    ygl: 'ygl',
    sherpa: 'sherpa',
    welcome_home: 'welcome_home',
    funnel: 'funnel',
    realpage_lead2lease: 'realpage_lead2lease',
    realpage_onesite: 'realpage_onesite',
    zoho: 'zoho',
    knock: 'knock',
    knock_api: 'knock_api',
    glennis_solutions: 'glennis_solutions',
    rent_dynamics: 'rent_dynamics',
    exacare: 'exacare',
    alis: 'alis',
    fortress: 'fortress',
    hubspot: 'hubspot',
    resman: 'resman',
    backoffice: 'backoffice',
};

export const crmConfigTypeLabels = {
    adf: 'ADF',
    anyone_home: 'Anyone Home',
    eldermark: 'Eldermark',
    eldermark_v2: 'Eldermark V2',
    enquire: 'Enquire',
    entrata: 'Entrata',
    hospice_md: 'Hospice MD',
    knock: 'Knock',
    knock_api: 'Knock API',
    realpage_lead2lease: 'Lead2Lease by RealPage',
    meet_elise: 'MeetElise',
    realpage_onesite: 'OneSite by RealPage',
    realpage: 'RealPage',
    rentcafe: 'RENTCafé',
    rentcafe_v2: 'RENTCafé V2',
    rent_manager: 'Rent Manager',
    sherpa: 'Sherpa',
    welcome_home: 'WelcomeHome',
    funnel: 'Funnel Leasing',
    yardi: 'Yardi',
    yardi_soap: 'Yardi Senior Housing',
    yardi_sipp: 'Yardi SIPP',
    ygl: `You've Got Leads`,
    zoho: 'Zoho',
    glennis_solutions: 'Glennis Solutions',
    rent_dynamics: 'Rent Dynamics',
    exacare: 'Exacare',
    alis: 'Alis',
    fortress: 'Fortress',
    hubspot: 'HubSpot',
    resman: 'Resman',
    backoffice: 'BackOffice CRM',
};

export const crmConfigTypeLabelArray = (exclude?: Array<string>) => {
    return Object.entries(crmConfigTypeLabels)
        .map(([val, label]) => {
            return { val, label };
        })
        .filter((entry: { val: string; label: string }) => {
            return !exclude || !exclude.includes(entry.val);
        })
        .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0));
};
